export default __webpack_public_path__ + "static/media/dreamstime_xs_106176433.88afc92f.jpg";